import axios from "axios";
import env from "../env";
import customConfig from "../config";

export const getAllLoyaltySpecData = async ({ page, size }) => {
  try {
    const response = await axios.get(
      `${env.GET_DEVICEMANAGEMENT_API_URL()}/simplifi/v1/appsupport/rewards/spec`,
      {
        params: {
          page,
          size,
        },
      }
    );
    // console.log("getAllLoyaltySpecData response---", response);
    /**
     * Success case
     * Always return a consistent shape
     */
    return {
      success: true,
      data: response?.data ?? [],
      message: customConfig.FETCH_SUCCESS,
    };
  } catch (error) {
    // console.log("getAllLoyaltySpecData error---", error, error?.response, error?.request);
    /**
     * Handle different error scenarios
     */

    // Backend responded with error status
    if (error?.response) {
      return {
        success: false,
        data: [],
        message: error.response?.data?.message || customConfig.FETCH_FAILURE,
        status: error.response?.status,
      };
    }

    // Network / CORS / timeout error
    if (error?.request) {
      return {
        success: false,
        data: [],
        message: customConfig.NETWORK_ERROR,
      };
    }

    // Unknown error
    return {
      success: false,
      data: [],
      message: error?.message || customConfig.SOMETHING_WENT_WRONG,
    };
  }
};

export const addLoyaltySpecData = async ({ body }) => {
  try {
    const response = await axios.post(
      `${env.GET_DEVICEMANAGEMENT_API_URL()}/simplifi/v1/appsupport/rewards/spec`,
      body
    );
    // console.log("addLoyaltySpecData response---", response);
    /**
     * Success case
     * Always return a consistent shape
     */
    return {
      success: true,
      data: response?.data ?? [],
      message: customConfig.ADD_SUCCESS,
    };
  } catch (error) {
    // console.log("addLoyaltySpecData error---", error, error?.response, error?.request);

    /**
     * Handle different error scenarios
     */

    // Backend responded with error status
    if (error?.response) {
      return {
        success: false,
        data: [],
        message: error.response?.data?.message || customConfig.ADD_FAILURE,
        status: error.response?.status,
      };
    }

    // Network / CORS / timeout error
    if (error?.request) {
      return {
        success: false,
        data: [],
        message: customConfig.NETWORK_ERROR,
      };
    }

    // Unknown error
    return {
      success: false,
      data: [],
      message: error?.message || customConfig.SOMETHING_WENT_WRONG,
    };
  }
};


export const updateLoyaltySpecData = async ({ body }) => {
  // let actionId = body?.action
  // delete body?.action;
  const actionId = body && body?.action;
  if (body && Object.prototype.hasOwnProperty.call(body, 'action')) {
    delete body.action;
  }

  try {
    // const response = await axios.put(
    //   `${env.GET_DEVICEMANAGEMENT_API_URL()}/simplifi/v1/appsupport/rewards/spec?action=${actionId}`,
    //   body
    // );
    const baseUrl = `${env.GET_DEVICEMANAGEMENT_API_URL()}/simplifi/v1/appsupport/rewards/spec`;
    const url = actionId !== undefined && actionId !== null ? `${baseUrl}?action=${encodeURIComponent(actionId)}` : baseUrl;
    const response = await axios.put(url, body);

    // console.log("updateLoyaltySpecData response---", response);
    /**
     * Success case
     * Always return a consistent shape
     */
    return {
      success: true,
      data: response?.data ?? [],
      message: customConfig.UPDATE_SUCCESS,
    };
  } catch (error) {
    // console.log("updateLoyaltySpecData error---", error, error?.response, error?.request);

    /**
     * Handle different error scenarios
     */

    // Backend responded with error status
    if (error?.response) {
      return {
        success: false,
        data: [],
        message: error.response?.data?.message || customConfig.UPDATE_FAILURE,
        status: error.response?.status,
      };
    }

    // Network / CORS / timeout error
    if (error?.request) {
      return {
        success: false,
        data: [],
        message: customConfig.NETWORK_ERROR,
      };
    }

    // Unknown error
    return {
      success: false,
      data: [],
      message: error?.message || customConfig.SOMETHING_WENT_WRONG,
    };
  }
};


export const deleteLoyaltySpecData = async ({ body }) => {
  const actionId = body && body?.action;
  try {
    const baseUrl = `${env.GET_DEVICEMANAGEMENT_API_URL()}/simplifi/v1/appsupport/rewards/spec`;
    const url = actionId !== undefined && actionId !== null ? `${baseUrl}?action=${encodeURIComponent(actionId)}` : baseUrl;
    const response = await axios.delete(url);

    // console.log("deleteLoyaltySpecData response---", response);
    /**
     * Success case
     * Always return a consistent shape
     */
    return {
      success: true,
      data: response?.data ?? [],
      message: customConfig.DELETE_SUCCESS,
    };
  } catch (error) {
    // console.log("deleteLoyaltySpecData error---", error, error?.response, error?.request);

    /**
     * Handle different error scenarios
     */

    // Backend responded with error status
    if (error?.response) {
      return {
        success: false,
        data: [],
        message: error.response?.data?.message || customConfig.DELETE_FAILURE,
        status: error.response?.status,
      };
    }

    // Network / CORS / timeout error
    if (error?.request) {
      return {
        success: false,
        data: [],
        message: customConfig.NETWORK_ERROR,
      };
    }

    // Unknown error
    return {
      success: false,
      data: [],
      message: error?.message || customConfig.SOMETHING_WENT_WRONG,
    };
  }
};